const CustomAlert = ({ message, onClose, isOpen }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full mx-4 transform transition-all animate-[slideIn_0.3s_ease-out]">
        <div className="flex items-center gap-4">
          {/* Updated gradient circle */}
          <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#1ab7ea] to-[#1877F2] rounded-full flex items-center justify-center">
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          </div>

          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900">
              Authentication Required
            </h3>
            <p className="text-gray-600 mt-1">{message}</p>
          </div>
        </div>

        {/* Updated button gradient */}
        <button
          onClick={onClose}
          className="mt-6 w-full bg-gradient-to-r from-[#1ab7ea] to-[#1877F2] text-white font-semibold py-3 px-4 rounded-lg hover:from-[#1877F2] hover:to-[#1ab7ea] transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default CustomAlert;
